import { Action, createReducer, on } from '@ngrx/store';
import { loadNewTab, removeNewTab } from '../actions/newTabOpen.actions';

export const initialState: { isNewTabOpen: boolean } = { isNewTabOpen: false };

const newTabReducer = createReducer(
  initialState,
  on(loadNewTab, (state, { isNewTabOpen }) => ({ ...state, isNewTabOpen })),
  on(removeNewTab, (state, { isNewTabOpen }) => ({ isNewTabOpen })),
);
export function reducer(state: { isNewTabOpen: boolean, id: string }, action: Action) {
  return newTabReducer(state, action);
}
